<template>
    <div>
        <Wp_nav_bar title="美团领红包"></Wp_nav_bar>
        <div>

        </div>
    </div>
</template>

<script>
    import {getMeituanPid} from "../../../js_meituan/utils_mt";
    import Wp_nav_bar from "../../custom/Wp_nav_bar";

    export default {
        name: "Wp_mt_share_page",
        components: {Wp_nav_bar},
        data(){
            return{
                meituan_pid: '',
            }
        },

        created() {
            this.initMtAuth();
        },
        methods:{
            /**
             * 授权美团pid，即获取美团pid
             */
            initMtAuth(){
                this.meituan_pid = this.$store.state.meituan_pid;
                if(!this.meituan_pid){
                    let params = {
                        uid: this.$store.state.username
                    };
                    this.$getMeituanPid(params, response=>{
                        if(response && response.code === 200){
                            let _meituan_pid = response.meituan_pid;
                            this.meituan_pid = _meituan_pid;

                            let user = this.$store.state;
                            user.meituan_pid = _meituan_pid;
                            this.$store.commit('login', user);
                        }
                    })
                }
            },
        }
    }
</script>

<style scoped>

</style>